import React from 'react';
import MetaTags from './components/MetaTags';
import AppBar from './components/AppBar'
import { Container,Row,Col } from 'react-bootstrap'
import { PiMapPinSimpleAreaBold } from "react-icons/pi";
import { BiPhoneCall } from "react-icons/bi";
import { MdOutlineAlternateEmail } from "react-icons/md";
import Mark from './components/Mark';
const ContactUs = () => {
  return (
    <div>
       <MetaTags
        title="Contact Us - KSR Crackers - Whole sale Crackers"
        type="website"
        siteName="ksrcrackers.com"
        url="https://ksrcrackers.com/contactus"
        keywords="Contact Us | KSR Crackers "
        description="Contact for wholesale Crackers and Retail Crackers"
        revisitAfter="10 Days"
      />
      <AppBar/>
      <img src={require('../assets/images/banner_three.jpg')} className='img-fluid w-100' alt='product name' />
        <Container className='padding'>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} className='py-3'>
                <h1 className='bold  text-center'> Contact Us</h1>
              </Col>
              <Col lg="4" md="12" className='py-3'>
                    <div className='box'>
                        <div className='box-icon'>
                          <PiMapPinSimpleAreaBold size={40} color={'#000'} />
                        </div>
                        <div className='regular'>
                        No.3/1362/C4/1, Bharathi Nagar, Sattur Road, <br/>
                            Sivakasi - 626189
                        </div>
                    </div>
                  </Col>
                  <Col lg="4" className='py-3'>
                    <div className='box'>
                        <div className='box-icon'>
                        <BiPhoneCall size={40} color={'#000'}/>
                        </div>
                        <div>
                        <li>+91 8807661233</li>
                        <li>+91 8351074080</li>
                        </div>
                    </div>
                  </Col>
                  <Col lg="4" className='py-3'>
                    <div className='box'>
                        <div className='box-icon'>
                          <MdOutlineAlternateEmail size={40} color={'#000'}/>
                        </div>
                        <div className='pb-4'>
                          <div>ksrcrackers@gmail.com</div> 
                        </div>
                    </div>
                  </Col>
             
              <Col lg='12' md="12" xs="12" className='py-5'>
                <>
                
               
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d445.21487334356794!2d77.8091066658122!3d9.436514152865568!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2sin!4v1725535583729!5m2!1sen!2sin"
                    width="100%"
                    height="600"
                    style={{ border: 0 }}
                    allowFullScreen
                    title="Google Maps Embed of Sivakasi, Tamil Nadu"
                  />
                </>
              </Col>
            
              
            </Row>
        </Container>
    
      
        <>
        <Mark/>
        </>
    </div>
  )
}

export default ContactUs